import { SELECT_TAG} from '../constants/actionTypes';

export default (selectedTag = "", action) => {
  switch (action.type) {
    case SELECT_TAG:
      return action.payload;
    default:
      return selectedTag;
  }
};